import { render, staticRenderFns } from "./form-mail-flat-crm.vue?vue&type=template&id=3f91a90f&scoped=true"
import script from "./form-mail-flat-crm.vue?vue&type=script&lang=js"
export * from "./form-mail-flat-crm.vue?vue&type=script&lang=js"
import style0 from "./form-mail-flat-crm.vue?vue&type=style&index=0&id=3f91a90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91a90f",
  null
  
)

export default component.exports